import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { AppConfig } from 'client/app/app.config';
import { OrderService } from '@services/order-service/order.service';
import { Entity } from '@cureskin/api-client-rn';

@Component({
  selector: 'packing-order',
  templateUrl: './packing-order.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class PackingOrderComponent implements OnInit {

  public readonly appConfig: AppConfig = inject(AppConfig);
  private readonly conn: ConnectionService = inject(ConnectionService);
  private readonly orderService: OrderService = inject(OrderService);

  @Input('order') order: any;
  @Output('addEvents') addEvents: EventEmitter<any> = new EventEmitter();
  orderedProductsCount: number;
  cancelledProducts: Array<NonNullable<Entity['Order']['productApprovalDetails']>['productDetails'][number]> = [];
  shouldShowPartialOrderCancellationUI: boolean;
  cancelledProductsCount: number = 0;
  totalProductsCount: number = 0;
  user: any;
  constructor() { }

  ngOnInit(): void {
    this.user = this.conn.getActingUser();
    const approvalData = this.orderService.initializeProductApprovalData(this.order);
    this.cancelledProducts = approvalData.cancelledProducts;
    this.orderedProductsCount = approvalData.orderedProductsCount;
    this.shouldShowPartialOrderCancellationUI = approvalData.shouldShowPartialOrderCancellationUI;
    this.cancelledProductsCount = approvalData.cancelledProductsCount;
    this.totalProductsCount = approvalData.totalProductsCount;
  }

  handleClick(): void {
    this.addEvents.emit();
  }
}
